import { queryOptions } from "@tanstack/react-query";
import { fetchBoundedBytes } from "@wags/reliability/bounded-http.ts";
import { STREAMED_QUERY_RETRY } from "@/lib/core/query-retry";
import { LocationEstimateResponseSchema } from "./viewer-location.contract";

export type UserLocation = {
    lat: number;
    lon: number;
};

export async function fetchApproximateLocation(): Promise<UserLocation> {
    const url = new URL("/api/location/estimate", window.location.origin);
    const response = await fetchBoundedBytes(url, {
        acceptedStatuses: Array.from(
            { length: 500 },
            (_, index) => index + 100,
        ),
        allowedHosts: [url.host],
        allowedProtocols: [url.protocol],
        allowPrivateAddress: true,
        maxRedirects: 5,
        maxResponseBytes: 64 * 1024,
        timeoutMs: 30_000,
    });
    if (response.status < 200 || response.status >= 300) {
        throw new Error("Failed to fetch approximate location");
    }

    const parsed = LocationEstimateResponseSchema.safeParse(
        JSON.parse(new TextDecoder().decode(response.bytes)),
    );
    if (!parsed.success) {
        throw new Error("Invalid approximate location data");
    }

    return {
        lat: parsed.data.latitude,
        lon: parsed.data.longitude,
    };
}

export const IP_LOCATION_QUERY_KEY = ["ip-location"];

export function ipLocationQueryOptions() {
    return queryOptions({
        queryKey: IP_LOCATION_QUERY_KEY,
        queryFn: fetchApproximateLocation,
        staleTime: Number.POSITIVE_INFINITY,
        gcTime: Number.POSITIVE_INFINITY,
        ...STREAMED_QUERY_RETRY,
    });
}
